import { useSharedModelController } from '../../../hooks/use-shared-model-controller';
import { initialNotificationsListModel } from './models/notifications-list';
import { NotificationController } from './notifications-controller';

export function useNotifications() {
  const { model: notificationsModel, delegate: notificationsDelegate } = useSharedModelController(
    initialNotificationsListModel,
    NotificationController
  );
  return { notificationsModel, notificationsDelegate };
}
